/** Limit czasu jednego zapytania do AI (serwer sam czeka na DeepSeek do 12 s). */
const TIMEOUT_MS = 15_000;

// Serwer bez klucza DeepSeek odpowiada 503 ai_disabled — do końca sesji już nie pytamy.
let disabled = false;

/** Serwer nie ma AI (do końca sesji) — akcje „z AI” można schować. */
export const aiDisabled = () => disabled;

/** Nazwa w zapytaniu do AI — serwer przyjmuje 1–120 znaków (dłuższa odrzuciłaby całe zapytanie). */
export const aiName = (name: string | null | undefined) => (name ?? '').trim().slice(0, 120);

/**
 * Zapytanie do /api/ai/*. AI to dodatek: offline, przy błędzie, limicie albo bez klucza zwraca null
 * (aplikacja działa wtedy jak bez AI, bez komunikatów o błędach).
 */
export async function aiCall<T>(path: string, body: unknown, signal?: AbortSignal): Promise<T | null> {
  if (disabled || !navigator.onLine || signal?.aborted) return null;
  // Własny kontroler zamiast AbortSignal.any/timeout (starsze Safari).
  const ctrl = new AbortController();
  const abort = () => ctrl.abort();
  const timer = setTimeout(abort, TIMEOUT_MS);
  signal?.addEventListener('abort', abort);
  try {
    const res = await fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl.signal,
    });
    const data: unknown = res.headers.get('content-type')?.includes('json') ? await res.json().catch(() => null) : null;
    if (res.ok) return data as T;
    if (res.status === 503 && (data as { error?: string } | null)?.error === 'ai_disabled') disabled = true;
    return null;
  } catch {
    // offline, przerwane albo po czasie
    return null;
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', abort);
  }
}
